import React from "react";

import {
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";

export default function ConvocationsPagination({
  page,
  pageCount,
  onPageChange,
}) {
  if (pageCount <= 1) {
    return null;
  }

  return (
    <nav
      aria-label="Pagination des événements"
      className="mt-5 flex flex-col items-center justify-between gap-3 rounded-3xl border border-slate-200 bg-white px-4 py-4 shadow-sm dark:border-slate-800 dark:bg-slate-900 sm:flex-row"
    >
      <p className="text-sm text-slate-500 dark:text-slate-400">
        Page{" "}
        <span className="font-semibold text-slate-900 dark:text-white">
          {page}
        </span>{" "}
        sur{" "}
        <span className="font-semibold text-slate-900 dark:text-white">
          {pageCount}
        </span>
      </p>

      <div className="grid w-full grid-cols-2 gap-2 sm:flex sm:w-auto">
        <button
          type="button"
          onClick={() =>
            onPageChange(
              Math.max(1, page - 1),
            )
          }
          disabled={page <= 1}
          className="inline-flex h-10 items-center justify-center gap-2 rounded-xl border border-slate-300 bg-white px-4 text-sm font-semibold text-slate-700 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-40 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200 dark:hover:bg-slate-800"
        >
          <FaChevronLeft />
          Précédent
        </button>

        <button
          type="button"
          onClick={() =>
            onPageChange(
              Math.min(pageCount, page + 1),
            )
          }
          disabled={page >= pageCount}
          className="inline-flex h-10 items-center justify-center gap-2 rounded-xl border border-slate-300 bg-white px-4 text-sm font-semibold text-slate-700 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-40 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200 dark:hover:bg-slate-800"
        >
          Suivant
          <FaChevronRight />
        </button>
      </div>
    </nav>
  );
}